import React, { useState } from "react";
import "./HairPage.css";
import {
    FLAG_TRANSLATIONS,
    INGREDIENTS_EXPLANATIONS,
    FLAG_ICONS_COLORS,
    CHEMICALS,
    categoryTitles,
    getIconForCategory,
    FLAG_DESCRIPTIONS,
    notableEffects,
    getSafetyClass,
    HAIR_AND_SCALP_TYPES,
    OVERALL_TO_STATUS,
    isSkinCategory,
    isWaterBased,
    skinNotableEffects,
    getTotalScoreClass,
    getScoreStyle,
    SKIN_TYPES,
} from "../constants";
import { useNavigate } from "react-router-dom";
import Reviews from "./Reviews";
import { useCompare } from "../CompareContext";
import products from "../hair_products.json";
import { getProductImage } from "../constants";
import ingredientData from '../final_ingredient_tr_data.json'
import ecomercekIngredients from '../ecomercek_ingredients.json';

const getIngredientDetails = (ingredientName) => {
    const formattedName = ingredientName.toUpperCase();
    let ingredientDetails = { ...ingredientData[formattedName] } || {};
    if (!ingredientDetails.tr) {
        Object.values(ecomercekIngredients).forEach(category => {
            const match = category.find(item => item.name.toUpperCase() === formattedName);
            if (match) {
                ingredientDetails.tr = match.alt_name;
            }
        });
    }
    return ingredientDetails;
};

const getScoreClass = (score) => {
    const numScore = Number.parseInt(score)
    if (numScore < 2.5) return "modal-score-0"
    if (numScore >= 7) return "modal-score-4"
    if (numScore >= 2.5) return "modal-score-2"
    return "modal-score-unknown"
}

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

const IngredientModal = ({ ingredient, onClose, position }) => {
    if (!ingredient) return null;
    const { score, functions = [], concerns = [], tr } = ingredient;

    return (
        <div className="modal-overlay-custom" onClick={onClose}>
            <div
                className="modal-content-custom"
                onClick={(e) => e.stopPropagation()}
                style={{
                    top: `${position.top}px`,
                    left: `${position.left}px`,
                }}
            >
                <div className="modal-header">
                    <span className={`modal-score-badge ${getScoreClass(score)}`}>{score}</span>
                    <div className="modal-ingredient-name-wrapper">
                        <span className="modal-ingredient-name">
                            {capitalizeFirstLetter(ingredient.name)}
                        </span>
                        {tr && <span className="modal-ingredient-tr-name">{`  (${tr})`}</span>}
                    </div>
                    <button className="modal-close-button" onClick={onClose}>×</button>
                </div>

                {functions.length > 0 && (
                    <>
                        <div className="modal-section-title">İşlevler:</div>
                        <div className="modal-functions">
                            {functions.map((func, i) => (
                                <span key={i} className="modal-function-badge">
                                    {func}
                                </span>
                            ))}
                        </div>
                    </>
                )}

                {concerns.length > 0 && (
                    <>
                        <div className="modal-section-title">Endişeler:</div>
                        <div className="modal-concerns">
                            {concerns.map((concern, i) => (
                                <span key={i} className="modal-concern-item">
                                    {concern}
                                </span>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const HairPage = ({ product }) => {
    const [activeTab, setActiveTab] = useState("genel");
    const [expandedHairType, setExpandedHairType] = useState(null);
    const [expandedFlag, setExpandedFlag] = useState(null);
    const [showInfo, setShowInfo] = useState(false);
    const [expandedIngredient, setExpandedIngredient] = useState(null);
    const [showAllIngredients, setShowAllIngredients] = useState(false);
    const navigate = useNavigate();
    const { addToCompare } = useCompare();
    const [selectedIngredient, setSelectedIngredient] = useState(null)
    const [modalPosition, setModalPosition] = useState({ top: "50%", left: "50%" })

    const handleIngredientClick = (ingredient, event) => {
        const rect = event.currentTarget.getBoundingClientRect();

        const modalWidth = 250;
        const modalHeight = 200;
        const padding = 10;
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        const viewWidth = window.innerWidth;
        const viewHeight = window.innerHeight;

        let left = rect.left + scrollX;
        let top = rect.top + scrollY;

        left -= (modalWidth - rect.width) / 2;
        top += rect.height + padding;

        if (top + modalHeight > scrollY + viewHeight - padding) {
            top = rect.top + scrollY - modalHeight - padding;
        }

        left = Math.max(scrollX + padding, Math.min(left, scrollX + viewWidth - modalWidth - padding));

        top = Math.max(scrollY + padding, top);

        setModalPosition({ top, left: "60" });
        setSelectedIngredient({ name: ingredient, ...getIngredientDetails(ingredient) });
    };

    const toggleHairTypeDetails = (type, status) => {
        if (status === "unknown") return;
        setExpandedHairType((prev) => (prev === type ? null : type));
    };

    const allFlags = Object.keys(FLAG_TRANSLATIONS);

    const toggleIngredientDetails = (ingredient) => {
        setExpandedIngredient((prev) => (prev === ingredient ? null : ingredient));
    };

    const toggleInfo = () => {
        setShowInfo((prev) => !prev);
    };

    const handleCompareClick = () => {
        addToCompare(product);
        navigate("/select-products");
    };

    const renderLabels = (labels) => {
        return (
            <div className="ingredient-labels">
                {labels.map((label) => (
                    <span
                        key={label}
                        className={`ingredient-badge ${label === "eczema_friendly"
                            ? "friendly"
                            : label === "eczema_risk"
                                ? "risky"
                                : label === "banned_eu"
                                    ? "banned"
                                    : ""
                            }`}
                    >
                        {label === "banned_eu" && "❌ Yasaklı (AB)"}
                        {label === "eczema_risk" && "⚠️ Egzama Riski"}
                        {label === "eczema_friendly" && "😊 Egzema Dostu"}
                    </span>
                ))}
            </div>
        );
    };

    const renderFlagElements = (flags) => {
        if (product.flags) {
            return flags.map((flag) => {
                const flagData = product.flags[flag] || [];
                const isFree = flagData.length === 0;
                const isExpanded = expandedFlag === flag;

                return (
                    <div key={flag}>
                        <div
                            className={`flag-item ${isFree ? "free" : "not-free"} ${isExpanded ? "expanded" : ""}`}
                            onClick={() => setExpandedFlag(isExpanded ? null : flag)}
                        >
                            <div className="flag-header">
                                <div className="flag-icon" style={{ color: FLAG_ICONS_COLORS[flag]?.color }}>
                                    {FLAG_ICONS_COLORS[flag]?.icon}
                                </div>
                                <p>
                                    {FLAG_TRANSLATIONS[flag]}{" "}
                                    <strong>{isFree ? "İçermez" : "İçerir"}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    };

    const renderExpandedContent = (flags) => {
        if (product.flags) {
            return (
                <>
                    {flags.map((flag, index) => {
                        const flagIngredients = product.flags[flag] || []
                        const isExpanded = expandedFlag === flag

                        if (!isExpanded) return null

                        return (
                            <div key={index} className="flag-details">
                                <div className="flag-description">
                                    <p>{FLAG_DESCRIPTIONS[flag]}</p>
                                </div>
                                {flagIngredients.length > 0 && (
                                    <div className="violating-ingredients">
                                        <h4>⚠️ İlgili İçerikler:</h4>
                                        <div className="ingredient-list">
                                            {flagIngredients.map((ingredient, i) => {
                                                const details = getIngredientDetails(ingredient)
                                                const safetyClass = getSafetyClass(details.score || "0")
                                                return (
                                                    <div
                                                        className={`ingredient-row ${safetyClass}`}
                                                        key={i}
                                                        onClick={(e) => handleIngredientClick(ingredient, e)}
                                                    >
                                                        <div className="modal-ingredient-name-wrapper">
                                                            <span className="ingredient-name">
                                                                {capitalizeFirstLetter(ingredient)}
                                                            </span>
                                                            {details.tr && <span className="modal-ingredient-tr-name">{`  (${details.tr})`}</span>}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </>
            )
        }
    }

    const renderNotableEffects = () => {
        const effectsList = isSkinCategory(product.category) ? skinNotableEffects : notableEffects;

        if (product.notable_effects) {
            return Object.entries(product.notable_effects).map(([effectKey, ingredients]) => {
                const effect = effectsList.find((e) => e.key === effectKey);
                if (!effect) return null;

                const isExpanded = expandedHairType === effectKey;

                return (
                    <div
                        key={effectKey}
                        className={`notable-effect-container ${isExpanded ? "expanded" : ""}`}
                    >
                        <div
                            className="notable-effect-header"
                            onClick={() => setExpandedHairType(isExpanded ? null : effectKey)}
                        >
                            <div className="effect-icon">{effect.icon}</div>
                            <span className="effect-title">{effect.label}</span>
                            <div className="effect-expand-indicator">{isExpanded ? "▲" : "▼"}</div>
                        </div>
                        {isExpanded && (
                            <div className="notable-effect-details">
                                {/* <p className="notable-effect-description">{effect.description}</p> */}

                                <p className="notable-effect-title">İçerikler:</p>
                                {ingredients.length > 0 && (
                                    <div className="ingredient-list">
                                        {ingredients.map((ingredient, idx) => {
                                            const details = getIngredientDetails(ingredient) || {}
                                            const backgroundClass = getSafetyClass(details.score || "0")
                                            return (
                                                <div
                                                    key={idx}
                                                    className={`ingredient-row ${backgroundClass}`}
                                                    onClick={(e) => handleIngredientClick(ingredient, e)}
                                                >
                                                    <div className="modal-ingredient-name-wrapper">
                                                        <span className="ingredient-name">
                                                            {capitalizeFirstLetter(ingredient)}
                                                        </span>
                                                        {details.tr && <span className="modal-ingredient-tr-name">{`  (${details.tr})`}</span>}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {selectedIngredient && (
                                    <IngredientModal
                                        ingredient={selectedIngredient}
                                        onClose={() => setSelectedIngredient(null)}
                                        position={modalPosition}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                );
            });
        }
    };

    const renderHairTypeTags = (typeGroup) => {
        const isSkin = typeGroup === "skin";
        const analysisData = isSkin ? product.skin_analysis || {} : product.hair_scalp_analysis?.[typeGroup] || {};
        const definitions = isSkin ? SKIN_TYPES.skin || {} : HAIR_AND_SCALP_TYPES[typeGroup] || {};

        return (
            <div className={`unique-${typeGroup}-container`}>
                {(typeGroup === "hair" || typeGroup === "scalp") &&
                    <h3 className="unique-type-group-title">
                        {typeGroup === "scalp" ? "Saç Derisi Tipi" : "Saç Tipi"}
                    </h3>
                }

                <div className="unique-compact-grid">
                    {Object.entries(analysisData).map(([key, { overall }]) => {
                        const status = OVERALL_TO_STATUS[overall] || "unknown";
                        const { icon, label } = definitions[key] || {};
                        const isExpanded = expandedHairType === key;

                        return (
                            <div key={key}>
                                <div
                                    className={`unique-card ${status}`}
                                    onClick={() => toggleHairTypeDetails(key)}
                                >
                                    <div className="unique-icon-label">
                                        <span className="unique-icon">{icon}</span>
                                        <span className="unique-label">{label}</span>
                                    </div>
                                    <div className={`unique-status ${status}`}>
                                        {status === "suitable" && "🥰 Uygun"}
                                        {status === "partially_suitable" && "🫤 Kısmen Uygun"}
                                        {status === "not_suitable" && "😖 Uygun Değil"}
                                        {status === "unknown" && "😶 Bilinmiyor"}
                                    </div>
                                </div>
                                {isExpanded && (
                                    <div className="unique-expanded-content">
                                        {renderExpandedHairType(typeGroup, key)}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderExpandedHairType = (typeGroup, key) => {
        const isSkin = typeGroup === "skin";
        const expandedItem = isSkin ? product.skin_analysis[key] : product?.hair_scalp_analysis?.[typeGroup]?.[key];
        if (!expandedItem) return null;
        const { found_good = [], found_bad = [] } = expandedItem;
        return (
            <div className="unique-expanded-details">
                {renderIngredientList(found_good, "Faydalı İçerikler", "unique-good-title")}
                {renderIngredientList(found_bad, "Zararlı İçerikler", "unique-bad-title")}
            </div>
        );
    };

    const renderIngredientList = (ingredients, title, titleClass) =>
        ingredients.length > 0 && (
            <>
                <p className={titleClass}>{title}</p>
                <div className="ingredient-list">
                    {ingredients.map((ingredient) => {
                        const details = getIngredientDetails(ingredient) || {}
                        const backgroundClass = getSafetyClass(details.score || "0")
                        return (
                            <div key={ingredient}
                                onClick={(e) => handleIngredientClick(ingredient, e)}
                                className={`ingredient-row ${backgroundClass}`}>
                                <div className="modal-ingredient-name-wrapper">
                                    <span className="ingredient-name">
                                        {capitalizeFirstLetter(ingredient)}
                                    </span>
                                    {details.tr && <span className="modal-ingredient-tr-name">{`  (${details.tr})`}</span>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        );

    const renderHarmfulChemicals = () => {
        return Object.entries(product.chemical_risks || []).map(([category, ingredients], index) => {
            const isExpanded = expandedHairType === category;
            return (
                <div
                    key={index}
                    className={`risky-item-container ${isExpanded ? "expanded" : ""}`}
                >
                    <div
                        className="risky-item-header"
                        onClick={() => setExpandedHairType(isExpanded ? null : category)}
                    >
                        <div className="effect-icon">{getIconForCategory(category)}</div>
                        <span className="risky-title">{categoryTitles[category] || category}</span>
                        <div className="risky-expand-indicator">{isExpanded ? "▲" : "▼"}</div>
                    </div>
                    {isExpanded && (
                        <div className="risky-item-details">
                            <h4>İçerikler:</h4>
                            {ingredients.length > 0 && (
                                <div className="ingredient-list">
                                    {ingredients.map((ingredient, idx) => {
                                        const chemicalDetails = CHEMICALS[category]?.find(
                                            (chem) => chem.name === ingredient
                                        );
                                        const riskLevel = chemicalDetails?.risk || "Bilinmiyor";
                                        const riskLabel =
                                            riskLevel === "High"
                                                ? "Yüksek"
                                                : riskLevel === "Moderate"
                                                    ? "Orta"
                                                    : riskLevel === "Low"
                                                        ? "Düşük"
                                                        : "Bilinmiyor";
                                        const safetyClass = getSafetyClass(
                                            riskLevel === "High"
                                                ? 3
                                                : riskLevel === "Moderate"
                                                    ? 2
                                                    : riskLevel === "Low"
                                                        ? 1
                                                        : 0
                                        );

                                        return (
                                            <div
                                                key={idx}
                                                className={`ingredient-row ${safetyClass}`}
                                                onClick={(e) => handleIngredientClick(ingredient, e)}
                                            >
                                                <span className="ingredient-name" title={chemicalDetails?.note || ""}>
                                                    {capitalizeFirstLetter(ingredient)} ({riskLabel})
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            );
        });
    };

    const productCategory = Object.keys(products).find((key) =>
        products[key].some((p) => p.barcode === product.barcode)
    );

    return (
        <div className="hair-page">
            <div className="product-card">
                <div className="image-container">
                    <img
                        src={getProductImage(productCategory, product.barcode, product.id)}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = product.image;
                        }}
                        alt={product.name}
                        className="product-image"
                    />
                    <div className="score-circle" style={getScoreStyle(product.total_score)}>
                        <span className="score-big">{product.total_score}</span>
                        <span className="score-small">/100</span>
                    </div>
                </div>
                <div className="text-content">
                    <h1 className="product-name">{product.name}</h1>
                    <h2 className="brand">{product.brand}</h2>
                    <button onClick={handleCompareClick} className="start-compare-button">
                        Karşılaştır
                    </button>
                    {isSkinCategory(product.category) && (
                        <div className="base-type-label">
                            {isWaterBased(product) ? (
                                <>
                                    <span className="icon">💧</span> Su Bazlı
                                </>
                            ) : (
                                <>
                                    <span className="icon">🛢️</span> Yağ Bazlı
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="tabs-container">
                <button
                    className={`tab-button ${activeTab === "genel" ? "active" : ""}`}
                    onClick={() => setActiveTab("genel")}
                >
                    Genel
                </button>
                <button
                    className={`tab-button ${activeTab === "riskler" ? "active" : ""}`}
                    onClick={() => setActiveTab("riskler")}
                >
                    Riskler
                </button>
                <button
                    className={`tab-button ${activeTab === "uygunluk" ? "active" : ""}`}
                    onClick={() => setActiveTab("uygunluk")}
                >
                    Uygunluk
                </button>
                <button
                    className={`tab-button ${activeTab === "icindekiler" ? "active" : ""}`}
                    onClick={() => setActiveTab("icindekiler")}
                >
                    İçindekiler
                </button>
                <button
                    className={`tab-button ${activeTab === "yorumlar" ? "active" : ""}`}
                    onClick={() => setActiveTab("yorumlar")}
                >
                    Yorumlar
                </button>
            </div>
            <div className="tab-content">
                {activeTab === "genel" && (
                    <>
                        <div className="section flags">
                            <div className="flags-grid">{renderFlagElements(allFlags.slice(0, 3))}</div>
                            {renderExpandedContent(allFlags.slice(0, 3))}
                            <div className="flags-grid" style={{ marginTop: "12px" }}>
                                {renderFlagElements(allFlags.slice(3, 6))}
                            </div>
                            {renderExpandedContent(allFlags.slice(3, 6))}
                        </div>
                        <div className="section">
                            <h2>Öne Çıkan Etkiler</h2>
                            <div className="effect-list">{renderNotableEffects()}</div>
                        </div>
                        {selectedIngredient && (
                            <IngredientModal
                                ingredient={selectedIngredient}
                                onClose={() => setSelectedIngredient(null)}
                                position={modalPosition}
                            />
                        )}
                    </>
                )}
                {activeTab === "riskler" && (
                    <div className="section">
                        <h2>Riskli İçerikler</h2>
                        <div className="effect-list">{renderHarmfulChemicals()}</div>
                        {selectedIngredient && (
                            <IngredientModal
                                ingredient={selectedIngredient}
                                onClose={() => setSelectedIngredient(null)}
                                position={modalPosition}
                            />
                        )}
                    </div>
                )}
                {activeTab === "uygunluk" && (
                    <div className="section">
                        <h2>{isSkinCategory(product.category) ? `Cilt Tipine Uygunluk` : `Saç ve Deri Tipine Uygunluk`}</h2>
                        {isSkinCategory(product.category) ?
                            <React.Fragment>
                                {renderHairTypeTags("skin")}
                            </React.Fragment>
                            : ["scalp", "hair"].map((typeGroup) => (
                                <React.Fragment key={typeGroup}>
                                    {renderHairTypeTags(typeGroup)}
                                </React.Fragment>
                            ))}
                        {selectedIngredient && (
                            <IngredientModal
                                ingredient={selectedIngredient}
                                onClose={() => setSelectedIngredient(null)}
                                position={modalPosition}
                            />
                        )}
                    </div>
                )}
                {activeTab === "icindekiler" && (
                    <div className="section ingredient-section">
                        <div className="info-header">
                            <h2>İçindekiler</h2>
                            <span className="info-icon" onClick={toggleInfo}>ℹ️</span>
                        </div>

                        {showInfo && (
                            <p className="info-text">
                                Ürün içerisindeki maddeler, sağlık üzerindeki etkilerine göre sınıflandırılmıştır:
                                <br />
                                <strong>🟢 Zararsız 🟡 Düşük Risk 🔴 Riskli ⚪ Bilinmiyor</strong>
                            </p>
                        )}

                        {(() => {
                            let ingredients = product.ingredients;
                            if (!ingredients || ingredients.length === 0) {
                                const subProductWithIngredients = product.other_links?.find(
                                    (sub) => sub.ingredients && sub.ingredients.length > 0
                                );
                                if (subProductWithIngredients) {
                                    ingredients = subProductWithIngredients.ingredients;
                                }
                            }
                            if (!ingredients || ingredients.length === 0) {
                                return <p>Bu ürünün içerik bilgisi bulunamadı.</p>;
                            }
                            return (
                                <>
                                    <div className="ingredient-list">
                                        {(showAllIngredients ? ingredients : ingredients.slice(0, 5))?.map((ingredient, index) => {
                                            const details = getIngredientDetails(ingredient) || {};
                                            const isExpanded = expandedIngredient === ingredient;
                                            const safetyClass = getSafetyClass(details.score || "0");
                                            const { score, functions = [], concerns = [], tr } = details;

                                            return (
                                                <div key={index} className={`ingredient-card ${isExpanded ? "expanded" : ""}`}>
                                                    <div
                                                        className={`ingredient-row ${safetyClass}`}
                                                        onClick={() => toggleIngredientDetails(ingredient)}
                                                    >
                                                        <div className="modal-ingredient-name-wrapper">
                                                            <span className="ingredient-name">
                                                                {capitalizeFirstLetter(ingredient)}
                                                            </span>
                                                            {tr && <span className="modal-ingredient-tr-name">{`  (${tr})`}</span>}
                                                        </div>
                                                        <span className="expand-indicator">{isExpanded ? "▲" : "▼"}</span>
                                                    </div>

                                                    {isExpanded && (
                                                        <div className="ingredient-details">
                                                            <div className="modal-header">
                                                                <span className={`modal-score-badge ${getScoreClass(score)}`}>
                                                                    {score}
                                                                </span>
                                                                <div className="modal-ingredient-name-wrapper">
                                                                    <span className="modal-ingredient-name">
                                                                        {capitalizeFirstLetter(ingredient)}
                                                                    </span>
                                                                    {tr && <span className="modal-ingredient-tr-name">{`  (${tr})`}</span>}
                                                                </div>
                                                            </div>

                                                            {functions.length > 0 && (
                                                                <>
                                                                    <div className="modal-section-title">İşlevler:</div>
                                                                    <div className="modal-functions">
                                                                        {functions.map((func, i) => (
                                                                            <span key={i} className="modal-function-badge">
                                                                                {func}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </>
                                                            )}

                                                            {concerns.length > 0 && (
                                                                <>
                                                                    <div className="modal-section-title">Endişeler:</div>
                                                                    <div className="modal-concerns">
                                                                        {concerns.map((concern, i) => (
                                                                            <span key={i} className="modal-concern-item">
                                                                                {concern}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {ingredients.length > 5 && (
                                        <button className="show-more-button" onClick={() => setShowAllIngredients(!showAllIngredients)}>
                                            {showAllIngredients ? "Daha Az Göster" : "Tümünü Göster"}
                                        </button>
                                    )}
                                </>
                            );
                        })()}
                    </div>
                )}
                {activeTab === "yorumlar" && (
                    <div className="section reviews">
                        <Reviews
                            starRating={product.star_rating?.toString()}
                            barcode={product.barcode}
                            category={product.category}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default HairPage;
